/**
 * Link to delete
 *
 * Usage:
 * <ma-delete-button entity="entity" entry="entry" size="xs"></ma-delete-button>
 */
export default function ezyDisableStoryDirective($state, $http, ReadQueries) {
    return {
        restrict: 'E',
        scope: {
            entity: '&',
            entityName: '@',
            entry: '&',
            size: '@',
            label: '@',
        },
        link: function (scope, element, attrs) {
            scope.label = scope.label || 'Disable';
            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
            var stateParams = entityName == $state.params.entity ? { ...$state.params } : {};
            stateParams.entity = entityName;
            stateParams.id = scope.entry().identifierValue;
            scope.stateParams = stateParams;
            scope.impersonate = () => {
                ReadQueries.getOne(scope.entity(), 'ShowView', stateParams.id, 'ShowView', null).then((entry) => {
                    console.log(entry)
                  $http({
                        method: 'POST', 
                        url: `https://app.ezyinsights.com/api/story/${entry.id}/hide`,
                        headers: {
                            'X-EzyInsights': BOA_SECURITY_KEY
                        },
                        withCredentials: true
                    }).success(() => {
                    alert('Story was hidden');
                  })
                }).catch((err) => console.error(err))
            };
        },
        template:
` <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ng-click="impersonate(stateParams)">
<span class="glyphicon glyphicon-user" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>
</a>`
    };
}

ezyDisableStoryDirective.$inject = ['$state', '$http', 'ReadQueries'];



// WEBPACK FOOTER //
// ./client/app/directives/ezyDisableStoryButton.js